export enum BootstrapIcon {
  PersonCircle = 'person-circle',
  SortUp = 'sort-up',
  SortDown = 'sort-down',
  InfoCircle = 'info-circle',
  Search = 'search',
  EmojiSmile = 'emoji-smile',
  ChevronDownIcon = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  List = 'list',
  X = 'x-lg',
  Bell = 'bell',
  Home = 'house',
  FileText = 'file-text',
  Gear = 'gear',
  Eye = 'eye',
  EyeSlash = 'eye-slash',
  Wallet = 'wallet',
  ShieldLock = 'shield-lock',
  PatchExclamation = 'patch-exclamation',
  Collection = 'collection',
  CheckLg = 'check-lg',
  DashLg = 'dash-lg',
  Box = 'box',
}

export function getBootstrapIconUrl(iconName: BootstrapIcon): string {
  return `https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/${iconName}.svg`
}

// Helper function to convert kebab-case to PascalCase and get icon URL
export function getBootstrapIconUrlByKey(iconKey: string): string {
  const enumKey = iconKey
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('') as keyof typeof BootstrapIcon

  if (!(enumKey in BootstrapIcon)) {
    throw new Error(`Icon '${iconKey}' (${enumKey}) is not in the pre-approved BootstrapIcon enum`)
  }

  // Get the enum value and return the URL
  const iconEnumValue = BootstrapIcon[enumKey]
  return getBootstrapIconUrl(iconEnumValue)
}
